; (function () {
    var
        _$wrapper = null,

        //our inner content, we are updating this with ajax
        _$divClientListContent = null,

        //set to true when a popup is open, can't open another
        _popup_open = false,

        //
        // init 
        //
        init = function () {
            _$wrapper = $('.layout-client-list');

            if (_$wrapper.length > 0) {
                //get the elems
                _$divClientListContent = _$wrapper.find('.clientPopup');
                addClient();
                editClient();
                disableEnterKey();

            }
        },


        //
        // setup the add client link
        //
        addClient = function () {
            $('#lnkAddClient').on('click', function () {

                if (!_popup_open) {
                    _popup_open = true;


                    delta.ajax.get(
                        '/client/AddEditClient',
                        function (html) {
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Add Company',
                                content: html,
                                /*css: 'modal-lg',*/
                                afterOpen: function () {
                                    _popup_open = false;
                                },
                                okCallback: function ($popup) {
                                    var formData = new FormData();
                                    $popup.find('.modal-body').find('input, select, textbox').each(function () {
                                        var $elem = $(this);
                                        formData.append($elem.attr('name'), $elem.val());
                                    });

                                    delta.ajax.postFormData(
                                        '/client/saveClient',
                                        formData,
                                        function (result) {
                                            if (result.isValid) {
                                                //close the popup
                                                delta.popup.close($popup);

                                                //update page
                                                _$divClientListContent.html(result.pageHtml);
                                            } else {
                                                $popup.find('.modal-body').html(result.popupHtml);
                                                delta.popup.enableButtons($popup);
                                            }
                                        }
                                    );

                                    return false;
                                }
                            });

                        }
                    );
                }
            });
        },

        //
        // setup the edit client link
        //
        editClient = function () {
            _$wrapper.on('click', '#lnkEditClient', function () {

                if (!_popup_open) {
                    _popup_open = true;

                    var $a = $(this);
                    var clientID = $a.attr('data-client-id');
                    var clientCode = encodeURIComponent($a.attr('data-client-code'));
                    var clientName = encodeURIComponent($a.attr('data-client-name'));

                    delta.ajax.get(
                        '/client/AddEditClient?clientID=' + clientID +
                        '&clientCode=' + clientCode +
                        '&clientName=' + clientName,
                        function (html) {
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Edit Company',
                                content: html,
                                /*css: 'modal-lg',*/
                                afterOpen: function () {
                                    _popup_open = false;
                                },
                                okCallback: function ($popup) {
                                    var formData = new FormData();
                                    $popup.find('.modal-body').find('input, select, textbox').each(function () {
                                        var $elem = $(this);
                                        formData.append($elem.attr('name'), $elem.val());
                                    });

                                    delta.ajax.postFormData(
                                        '/client/saveClient',
                                        formData,
                                        function (result) {
                                            if (result.isValid) {
                                                //close the popup
                                                delta.popup.close($popup);

                                                //update page
                                                _$divClientListContent.html(result.pageHtml);
                                            } else {
                                                $popup.find('.modal-body').html(result.popupHtml);
                                                delta.popup.enableButtons($popup);
                                            }
                                        }
                                    );

                                    return false;
                                }
                            });

                        }
                    );
                }
            });
        },
        disableEnterKey = function () {
            document.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                }
            });
        },
        dummy = function () { };

    $(document).ready(init);
})();